// extracted by mini-css-extract-plugin
export var copy = "styles-module--copy--JVhmz";
export var cta = "styles-module--cta--mvdTH";
export var links = "styles-module--links--Fy1uN";
export var locations = "styles-module--locations--7eI6y";